/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable import/no-cycle */
/* eslint-disable react/no-unescaped-entities */
import React, { FC } from 'react';
import { Formik, FormikProps } from 'formik';
import * as Yup from 'yup';

import Button from '../Button';
import { SKILLBUILDER_ERRORS } from '../../Constants/ErrorMessages';
import TextField from '../FormFields/TextField';
import Typo from '../Typo';
import { getFieldError } from '../FormFields/Utils';
import styles from './skillbuilderSubmissionForm.module.sass';
import useSkillBuilderActions from '../SkillBuilderDetail/useSkillBuilderAction';

export interface SkillBuilderSubmissionFormData {
  submission: string;
  score: number;
}

interface SkillBuilderFormProps {
  entryId: string;
  slug: string;
  earnPoints: number;
  setHasParticipated: React.Dispatch<React.SetStateAction<boolean>>;
  onSubmit: () => void;
}

const ValidationSchema = Yup.object().shape({
  submission: Yup.string().required(SKILLBUILDER_ERRORS.SKILLBUILDER_SUBMISSION_REQUIRED),
});

const SkillbuilderSubmissionForm: FC<SkillBuilderFormProps> = props => {
  const { entryId, slug, earnPoints, setHasParticipated, onSubmit } = props;
  const { handleCreateSkillbuilderSubmission } = useSkillBuilderActions(entryId ?? slug ?? '');
  return (
    <Formik<SkillBuilderSubmissionFormData>
      onSubmit={(val, helpers) => {
        handleCreateSkillbuilderSubmission
          .run({
            values: { ...val, score: earnPoints },
            formikHelpers: helpers,
          })
          .then(() => {
            onSubmit();
            return setHasParticipated(true);
          });
      }}
      initialValues={{} as SkillBuilderSubmissionFormData}
      validationSchema={ValidationSchema}
      enableReinitialize
    >
      {(formikProps: FormikProps<SkillBuilderSubmissionFormData>) => {
        const errors = {
          submission: getFieldError('submission', formikProps),
        };
        return (
          <form onSubmit={formikProps.handleSubmit} id="skillbuilder_form">
            <div className={`is-bgcolor-Grey py-6 px-3 has-text-centered ${styles.textEditor}`}>
              <div>
                <Typo h3 classes="mb-4">
                  Submit your work
                </Typo>
              </div>
              <div className="mb-3 is-bgcolor-White">
                <TextField
                  valueKey="submission"
                  rootClassName="is-bgcolor-Grey"
                  otherFieldProps={{
                    placeholder: 'Type your feedback here',
                    onChange: formikProps.handleChange,
                  }}
                  rows={10}
                  error={errors.submission}
                />
              </div>
              <div className="is-flex is-flex-direction-column mb-4">
                <Typo small>Note:</Typo>
                <Typo small>You may only make one submission to a Skillbuilder</Typo>
              </div>
              <Button
                theme="Filled - Lime"
                type="submit"
                classes={` ${
                  handleCreateSkillbuilderSubmission.status === 'PROCESSING' && 'is-loading'
                }`}
              >
                Submit
              </Button>
            </div>
          </form>
        );
      }}
    </Formik>
  );
};

export default SkillbuilderSubmissionForm;
